<!-- app.component.html -->
<div class="app-container" [ngClass]="{'full-page': isLoginPage}" [dir]="languageService.getDirection()">
  <app-navbar class="navbar"
    *ngIf="!isLoginPage"
    [isEtabSelected]="isEtabSelected"
    [selectedEtab]="selectedEtab"
    [userName]="userName"
    [isLoginPage]="isLoginPage"
    [isSidebarOpen]="isSidebarOpen"
    (sidebarToggled)="toggleSidebar($event)">
  </app-navbar>

  <div *ngIf="isLoginPage" class="full-content">
    <router-outlet></router-outlet>
    <app-footer></app-footer>
  </div>

  <mat-sidenav-container class="sidenav-container" *ngIf="!isLoginPage">
    <mat-sidenav #sidenav
                 [mode]="isLargeScreen ? 'side' : 'over'"
                 [opened]="isSidebarOpen"
                 class="sidenav"
                 [ngClass]="{'collapsed': !isSidebarOpen && isLargeScreen}">
      <app-sidebar
        [inscritsEnv]="inscritsEnv"
        [personnels]="personnels"
        [personnel]="personnel"
        [isSidebarOpen]="isSidebarOpen"
        [isEtabSelected]="isEtabSelected"
        (itemClicked)="closeSidebarOnMobile()">
      </app-sidebar>
    </mat-sidenav>
    
    <mat-sidenav-content class="main-content">
      <div class="content-wrapper">
        <router-outlet></router-outlet>
      </div>
      <app-footer *ngIf="!isLoginPage"></app-footer>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>